/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Start_NoteInputs */

const en_mk_start_note = /** @type {(inputs: Mk_Start_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If you already use another tool, you do not have to switch it off first. Many teams start with a single division here and leave the rest running as usual until they are convinced.`)
};

const id_mk_start_note = /** @type {(inputs: Mk_Start_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kalau Anda sudah memakai alat lain, tidak perlu mematikannya dulu. Banyak tim memulai dengan satu divisi saja di KerjaBareng dan membiarkan sisanya berjalan seperti biasa sampai yakin.`)
};

/**
* | output |
* | --- |
* | "If you already use another tool, you do not have to switch it off first. Many teams start with a single division here and leave the rest running as usual unt..." |
*
* @param {Mk_Start_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_start_note = /** @type {((inputs?: Mk_Start_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Start_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_start_note(inputs)
	return en_mk_start_note(inputs)
});